import { SET_CURRENT_PROJECT_ID, CLEAR_CURRENT_PROJECT_ID } from 'js/constants/actionTypes';

/**
 * Project Context Management Actions
 *
 * These actions were created to solve the problem of automatically assigning newly created flows
 * to a project when the user initiates flow creation from within a project context.
 *
 * SOLUTION:
 * These actions maintain the project context in Redux state throughout the flow creation process:
 *
 * 1. When user enters a project page → setCurrentProjectId(projectId) is dispatched
 * 2. Project ID is stored in Redux state (app.currentProject.currentProjectId)
 * 3. During flow creation, the currentProjectId is retrieved from Redux
 * 4. After flow is created, assignFlowToProject() uses the currentProjectId to auto-assign
 * 5. After assignment, clearCurrentProjectId() is called to prevent unintended future assignments
 */

/**
 * Sets the current project ID in Redux state.
 *
 * This establishes a project context that persists throughout the user's navigation
 * during flow creation. The project ID will be used to automatically assign any newly
 * created flows to this project.
 */
export const setCurrentProjectId = (projectId) => {
  return {
    type: SET_CURRENT_PROJECT_ID,
    payload: { projectId },
  };
};

/**
 * Clears the current project ID from Redux state.
 *
 * This action should be called after a flow has been successfully assigned to a project
 * or when the user exits the project context.
 */
export const clearCurrentProjectId = () => {
  return {
    type: CLEAR_CURRENT_PROJECT_ID,
  };
};
